import { useEffect } from 'react';

import useRaceStore from '@/stores/raceStore';
import RaceGrid from '@/components/RaceGrid';

import './styles.css';

const Index = () => {
  const { activeRaces, fetchActiveRaces } = useRaceStore();

  useEffect(() => {
    fetchActiveRaces();
  }, [fetchActiveRaces]);

  return (
    <div className="join-races-container pt-8">
      <div className="pb-8 text-sm leading-4">
        <div>Select Tokens and Stake.</div>
        <div>Staking Rewards update in Real time based on Staking Activity.</div>
      </div>
      <div className={`main-content`}>
        <RaceGrid isLoading={activeRaces.isLoading} isError={!!activeRaces.error} races={activeRaces.races} />
      </div>
    </div>
  );
};

export default Index;
